<table *ngFor="let text of textes" class="ir-plugin-table" style="margin-bottom: 10px">
  <tr *ngIf="text.Label">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ text.Label }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <p>
        <span class="ir-installationreceived_comment ir-ph1"></span>
      </p>
    </td>
  </tr>
  <tr *ngIf="text.HtmlContent">
    <td class="plugin-table-cell">
      <span>
        <strong>{{ 'plugins.installationfreetext.free-text' | translate }}</strong>
      </span>
    </td>
    <td class="plugin-table-cell">
      <div class="ir-plugin-values th-plugin-values angular-editor-view ir-ph1" [innerHtml]="text.HtmlContent"></div>
    </td>
  </tr>
</table>
